export default "__VITE_ASSET__BcvdU__p__"